import { useState } from "react";
import { Mail, Package } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { downloadFile } from "./PaymentLog";
import { Button } from "./ui/button";

export function WelcomePackButtons({ partnerId, size = "default" }) {
  const { isPartner, user } = useAuth();
  const [busy, setBusy] = useState(null);
  const pid = partnerId || user?.partner_id;
  const epil = !isPartner && user?.roles?.some((r) => ["Admin", "GM", "Finance"].includes(r));
  if (!pid || (!isPartner && !epil)) return null;
  const download = async () => { setBusy("dl"); await downloadFile(`/partners/${pid}/welcome-pack.zip`, "EPIL Welcome Pack.zip"); setBusy(null); };
  const send = async () => {
    setBusy("send");
    try { const { data } = await api.post(`/partners/${pid}/welcome-pack/send`); toast.success(`Welcome pack email recorded for ${data.recipients.join(", ")} – sending is off, it's in the outbox`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return (
    <div className="flex flex-wrap gap-2">
      <Button size={size} variant="outline" disabled={!!busy} onClick={download} data-testid="welcome-pack-download"><Package className="mr-1 h-4 w-4" />{busy === "dl" ? "Preparing…" : isPartner ? "Download my welcome pack" : "Download welcome pack"}</Button>
      {epil && <Button size={size} variant="outline" disabled={!!busy} onClick={send} data-testid="welcome-pack-send"><Mail className="mr-1 h-4 w-4" />Send welcome pack</Button>}
    </div>
  );
}
